export const QR_CODES_FEATURE_KEY = 'qrCodes';
